<template>
  <div>
    <app-header class="tophere" id="appHeader"></app-header>
    <router-view></router-view>
    <app-footer id="appFooter"></app-footer>
    <div class='scrolltop' style="z-index: 100;">
      <div class='scroll icon' @click="clickedSTT()">
        <i class="fa fa-4x fa-angle-up"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import header from "../header/Header";
  import footer from "../footer/Footer";

  export default {
    components: {
      appHeader: header,
      appFooter: footer
    },
    mounted() {
      if (this.$route.path == "/global/about-us") {
        $("#appHeader").hide();
      } else {
        $("#appHeader").show();
      }
      if (this.$route.path == "/engineer/skill-update" || this.$route.path == "/engineer/skill-update/") {
        $("#appFooter").hide();
      } else {
        $("#appFooter").show();
      }
      if ($(window).scrollTop() > 50) {
        $(".scrolltop:hidden")
          .stop(true, true)
          .fadeIn();
      } else {
        $(".scrolltop")
          .stop(true, true)
          .fadeOut();
      }
    },
    watch: {
      // call again the method if the route changes
      $route: "onRouteChange"
    },
    methods: {
      onRouteChange() {
        if (this.$route.path == "/global/about-us") {
          $("#appHeader").hide();
        } else {
          $("#appHeader").show();
        }
      },
      clickedSTT() {
         $("html,body").animate({scrollTop: $(".tophere").offset().top - 100}, "1000");
            return false
      }
    }
  };
</script>

<style scoped>
</style>
